import React from 'react'
import ApiUrl from '../../../../configTools/apiUrl';
import { Link } from 'react-router-dom';

const Top = ({openChatBox,setOpenChatBox}) => {
    const ChatBoxes = JSON.parse(localStorage.getItem("chat-boxes"));
    const closeChat = ()=>{
        var newchatboxes = [];
        if(ChatBoxes){
            for (let index = 0; index < ChatBoxes.length; index++) {
                const element = ChatBoxes[index];
                if(element.id != openChatBox.id){
                    newchatboxes.push(element)
                }
            }
        }
        localStorage.setItem("chat-boxes",JSON.stringify(newchatboxes));
        setOpenChatBox({
            id:0,
            userid:0,
            userimage:"",
            username:"",
            first:"",
            last:"",
            isUserA:false
        });
    }
  return (
        <div className='open_chatbox_top'>
            <div className='open_chatbox_top_in'>
                <div 
                    className='open_chatbox_top_image' 
                    style={{
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+openChatBox.userimage})`
                    }}
                >
                </div>
                <div className='open_chatbox_top_name'>
                    <Link to={'/user/'+openChatBox.username}>
                        <h4>{openChatBox.first} {openChatBox.last}</h4>
                        <h5>{openChatBox.username}</h5>
                    </Link>
                </div>
            </div>
            <div className='open_chatbox_top_buttons'>
                <button onClick={()=>{
                    setOpenChatBox({
                        id:0,
                        userid:0,
                        userimage:"",
                        username:"",
                        first:"",
                        last:"",
                        isUserA:false
                    });
                }}>_</button>
                <button onClick={closeChat}>X</button>
            </div>
        </div>
  )
}

export default Top
